/**
 * Whether the current member is a B2B/retailer customer.
 *
 * Reads the existing CartContext (no extra network request); the backend stamps
 * `isB2b` on the cart response from the member's content type (`b2bCustomer`).
 * Returns false for consumers and until the cart has loaded — leaf product
 * components fall back to the standard consumer price display in that window.
 */

import { useCart } from "@/hooks/useCart";

export function useIsB2b(): boolean {
  const { cart } = useCart();
  return cart?.isB2b ?? false;
}
